import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CustomsClient, CustomsHistoryModel, CustomsModel, DashboardModel, DocumentsModel, FileAuditModel, PagedListingResponseOfTourListHistoryModel, TourHistoryModel } from '@core/services/api.service';
import { CustomDocumentsService } from '@core/services/documentsUpload/custom.DocumentsService';
import { AddBmwMessageByIdAction, AddBmwMessageByIdFailAction, AddBmwMessageByIdSuccessAction, AddCustomsMessageByIdAction, AddCustomsMessageByIdFailAction, AddCustomsMessageByIdSuccessAction, AllocateUserByTourIdAction, AllocateUserByTourIdFailAction, AllocateUserByTourIdSuccessAction, ApplyFiltersToCustomsAction, DownloadDocumentAction, DownloadDocumentFailAction, DownloadDocumentSuccessAction, GetDocumentsByAmcoIdAction, GetDocumentsByAmcoIdFailAction, GetDocumentsByAmcoIdSuccessAction, LoadBmwHistoryAction, LoadBmwHistoryFailAction, LoadBmwHistorySuccessAction, LoadCustomsHistoryAction, LoadCustomsHistoryFailAction, LoadCustomsHistoryListAction, LoadCustomsHistoryListFailAction, LoadCustomsHistoryListSuccessAction, LoadCustomsHistorySuccessAction, LoadCustomsListAction, LoadCustomsListFailAction, LoadCustomsListSuccessAction, LoadListOfOpenChatsAction, LoadListOfOpenChatsFailAction, LoadListOfOpenChatsSuccessAction, MarkChatAsResolvedAction, MarkChatAsResolvedFailAction, MarkChatAsResolvedSuccessAction, RegisterSignalRForCustomsAction, SetCustomsCategoryFilterAction, SetCustomsDepartmentsFilterAction, SetCustomsStatusFilterAction, SetCustomsTypesFilterAction, SetDeclarationTypeAction, SetGoodsLoadedFilterAction, UpdateCustomByTourIdAction, UpdateCustomByTourIdFailAction, UpdateCustomByTourIdSuccessAction, UploadDocumentAction, UploadMultipleDocumentsAction, UploadMultipleDocumentsSuccessAction, UploadDocumentFailAction, UploadDocumentSuccessAction, ViewDocumentAction, ViewDocumentFailAction, GetDocumentTypesAction, GetDocumentTypesSuccessAction, GetDocumentTypesFailAction, UpdateDocumentTypeAction, UpdateDocumentTypeSuccessAction, UpdateDocumentTypeFailAction, ClearDocumentsAction, UpdateDocumentsCheckedAction, UpdateDocumentsCheckedSuccessAction, UpdateDocumentsCheckedFailAction, UpdateUncCheckedAction, UpdateUncCheckedSuccessAction, UpdateUncCheckedFailAction, UpdateTadClosedAction, UpdateTadClosedSuccessAction, UpdateTadClosedFailAction, SetHasNewMessagesForCustomsListAction, ClearNewMessagesForCustomsListAction, SetHasNewMessagesForManagedToursAction, ClearNewMessagesForManagedToursAction } from './customs.actions';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LoadCustomsDashboardsV1Action } from '@ngxs-store/dashboards-store/dashboards.actions';
import { SignalRService } from '@core/services/signalr.service';
import { HttpClient, HttpHeaders, HttpEventType, HttpEvent, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OpenSnackbarAction } from '@ngxs-store/ui-store/ui.actions';
import { SnackbarType } from '@core/models';
import { Store } from '@ngxs/store';
import { AuthState } from '@ngxs-store/auth-store/auth.state';

export class CustomsStateModel {
  public isLoading: boolean;
  public customsList: CustomsModel[];
  public filteredList: CustomsModel[];
  public selectedCategory: string;
  public selectedDepartments: number[];
  public selectedDeclarationType: string[];
  public selectedTypes: number[];
  public customsHistory: TourHistoryModel[];
  public customsHistoryList: PagedListingResponseOfTourListHistoryModel;
  public signalRHandlersRegistered: boolean;
  public customsMessages: CustomsHistoryModel[];
  public hasOpenChats: DashboardModel[];
  public selectedGoodsLoaded: boolean[];
  public selectedCustomsStatus: string[];
  public isAllocating: boolean;
  public isUploadingDocument: boolean;
  public documents: DocumentsModel[];
  public isLoadingDocuments: boolean;
  public documentTypes: FileAuditModel[];
  public isUpdatingDocumentType: boolean;
  public isUpdatingDocumentsChecked: boolean;
  public isUpdatingUncChecked: boolean;
  public isUpdatingTadClosed: boolean;
  public hasNewMessagesForCustomsList: boolean;
  public hasNewMessagesForManagedTours: boolean;
  public lastSentCustomsMessageTourId: number | null;
  public lastSentCustomsMessageAt: number | null;
}

@State<CustomsStateModel>({
  name: 'customs',
  defaults: {
    isLoading: false,
    filteredList: [],
    customsList: [],
    selectedCategory: '',
    selectedDepartments: [],
    selectedTypes: [],
    selectedDeclarationType: [],
    customsHistory: [],
    customsHistoryList: null,
    signalRHandlersRegistered: false,
    customsMessages: [],
    hasOpenChats: [],
    selectedGoodsLoaded: [],
    selectedCustomsStatus: [],
    isAllocating: false,
    isUploadingDocument: false,
    documents: [],
    isLoadingDocuments: false,
    documentTypes: [],
    isUpdatingDocumentType: false,
    isUpdatingDocumentsChecked: false,
    isUpdatingUncChecked: false,
    isUpdatingTadClosed: false,
    hasNewMessagesForCustomsList: false,
    hasNewMessagesForManagedTours: false,
    lastSentCustomsMessageTourId: null,
    lastSentCustomsMessageAt: null
    }
  })

@Injectable()
export class CustomsState {
  constructor(
    private customsClient: CustomsClient,
    public signalRService: SignalRService,
    private http : HttpClient,
    private cusDocumentsService: CustomDocumentsService,
    private store: Store
  ) { }

  @Selector()
  static getIsLoading(state: CustomsStateModel) {
    return state.isLoading;
  }

  @Selector()
  static getFilteredCustoms(state: CustomsStateModel) {
    return state.filteredList;
  }

  @Selector()
  static getSelectedDepartments(state: CustomsStateModel) {
    return state.selectedDepartments;
  }

  @Selector()
  static getSelectedtypes(state: CustomsStateModel) {
    return state.selectedTypes;
  }

  @Selector()
  static getSelectedDeclarationType(state: CustomsStateModel) {
    return state.selectedDeclarationType;
  }

  @Selector()
  static getCustomsHistoryList(state: CustomsStateModel) {
      return state.customsHistoryList;
  }

  @Selector()
  static getCustomsHistory(state: CustomsStateModel) {
      return state.customsHistory;
  }

  @Selector()
  static getMessagesHistory(state: CustomsStateModel) {
      return state.customsMessages;
  }

  @Selector()
  static getHasOpenMessages(state: CustomsStateModel) {
      return state.hasOpenChats;
  }

  @Selector()
  static getSelectedGoodsLoaded(state: CustomsStateModel) {
        return state.selectedGoodsLoaded;
  }

  @Selector()
    static getSelectedCustomsStatus(state: CustomsStateModel) {
        return state.selectedCustomsStatus;
    }

  @Selector()
   static getIsAllocating(state: CustomsStateModel) {
        return state.isAllocating;
    }

  @Selector()
    static getIsUploadingDocument(state: CustomsStateModel) {
        return state.isUploadingDocument;
    }

  @Selector()
    static getDocuments(state: CustomsStateModel) {
        return state.documents;
    }

  @Selector()
    static getIsLoadingDocuments(state: CustomsStateModel) {
        return state.isLoadingDocuments;
    }

  @Selector()
  static getDocumentTypes(state: CustomsStateModel) {
    return state.documentTypes;
  }

  @Selector()
  static getIsUpdatingDocumentType(state: CustomsStateModel) {
    return state.isUpdatingDocumentType;
  }

  @Selector()
  static getIsUpdatingDocumentsChecked(state: CustomsStateModel) {
    return state.isUpdatingDocumentsChecked;
  }

  @Selector()
  static getIsUpdatingUncChecked(state: CustomsStateModel) {
    return state.isUpdatingUncChecked;
  }

  @Selector()
  static getIsUpdatingTadClosed(state: CustomsStateModel) {
    return state.isUpdatingTadClosed;
  }

  @Selector()
  static getHasNewMessagesForCustomsList(state: CustomsStateModel) {
    return state.hasNewMessagesForCustomsList;
  }

  @Selector()
  static getHasNewMessagesForManagedTours(state: CustomsStateModel) {
    return state.hasNewMessagesForManagedTours;
  }

  /// Get List of customs
  @Action(LoadCustomsListAction)
  LoadCustomsListAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: LoadCustomsListAction) {
      patchState({ isLoading: true });

      return this.customsClient.getCustomsList().pipe(
          tap((customs) => dispatch(new LoadCustomsListSuccessAction({ customs }))),
          catchError((err) => dispatch(new LoadCustomsListFailAction()))
      );
  }

  @Action(LoadCustomsListSuccessAction)
  LoadCustomsListSuccessAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: LoadCustomsListSuccessAction) {
    patchState({
          isLoading: false,
          customsList: action.payload.customs
    });
    dispatch(new ApplyFiltersToCustomsAction());
  }

  @Action(LoadCustomsListFailAction)
  LoadCustomsListFailAction(ctx: StateContext<CustomsStateModel>, action: LoadCustomsListFailAction) {
    ctx.patchState({
        isLoading: false,
        customsList: []
    });
  }


  @Action(LoadCustomsHistoryListAction)
  LoadCustomsHistoryListAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: LoadCustomsHistoryListAction) {
      patchState({ isLoading: true });

      return this.customsClient.getCustomsHistory(action.payload.GetTourHistoryQuery).pipe(
          tap((tourHistoryList) => dispatch(new LoadCustomsHistoryListSuccessAction({ tourHistoryList }))),
          catchError((err) => dispatch(new LoadCustomsHistoryListFailAction()))
      );
  }

  @Action(LoadCustomsHistoryListSuccessAction)
  LoadCustomsHistoryListSuccessAction(ctx: StateContext<CustomsStateModel>, action: LoadCustomsHistoryListSuccessAction) {
      ctx.patchState({
          isLoading: false,
          customsHistory: action.payload.tourHistoryList.results,
          customsHistoryList: action.payload.tourHistoryList
      });
  }

  @Action(LoadCustomsHistoryListFailAction)
  LoadCustomsHistoryListFailAction(ctx: StateContext<CustomsStateModel>, action: LoadCustomsHistoryListFailAction) {
      ctx.patchState({
          isLoading: false,
          customsHistory: [],
          customsHistoryList: null
      });
  }

  //-----------------------------------------------------------------------------------------------------------------------------------------
  @Action(LoadListOfOpenChatsAction)
  LoadListOfOpenChatsAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: LoadListOfOpenChatsAction) {
      patchState({ isLoading: true });

      return this.customsClient.getListOfOpenChats().pipe(
          tap((dash) => dispatch(new LoadListOfOpenChatsSuccessAction({ dash }))),
          catchError((err) => dispatch(new LoadListOfOpenChatsFailAction()))
      );
  }

  @Action(LoadListOfOpenChatsSuccessAction)
  LoadListOfOpenChatsSuccessAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: LoadListOfOpenChatsSuccessAction) {
    patchState({
          isLoading: false,
          hasOpenChats: action.payload.dash
    });
  }

  @Action(LoadListOfOpenChatsFailAction)
  LoadListOfOpenChatsFailAction(ctx: StateContext<CustomsStateModel>, action: LoadListOfOpenChatsFailAction) {
    ctx.patchState({
        isLoading: false,
        hasOpenChats: []
    });
  }

   //----------------------------------------------------------------------------------------------------------------------------------------------------

   @Action(LoadCustomsHistoryAction)
   LoadCustomsHistoryAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: LoadCustomsHistoryAction) {
       patchState({ isLoading: true });

       return this.customsClient.getCustomsHistoryById(action.id, action.amcoId).pipe(
           tap((history) => dispatch(new LoadCustomsHistorySuccessAction({ history }))),
           catchError((err) => dispatch(new LoadCustomsHistoryFailAction()))
       );
   }

   @Action(LoadCustomsHistorySuccessAction)
   LoadCustomsHistorySuccessAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: LoadCustomsHistorySuccessAction) {
       patchState({
           isLoading: false,
           customsMessages: action.payload.history
       });
   }

   @Action(LoadCustomsHistoryFailAction)
   LoadCustomsHistoryFailAction(ctx: StateContext<CustomsStateModel>, action: LoadCustomsHistoryFailAction) {
       ctx.patchState({
           isLoading: false,
           customsMessages: []
       });
   }

     @Action(LoadBmwHistoryAction)
     LoadBmwHistoryAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: LoadBmwHistoryAction) {
       patchState({ isLoading: true });

       const url = `${environment.webApiBaseAddress}/api/BmwChats/GetBmwChatHistoryByTourId/${action.id}?amcoId=${action.amcoId}`;
       return this.http.get<any[]>(url).pipe(
         map((history) => (history || []).map((item) => CustomsHistoryModel.fromJS(item))),
         tap((history) => dispatch(new LoadBmwHistorySuccessAction({ history }))),
         catchError((err) => dispatch(new LoadBmwHistoryFailAction()))
       );
     }

     @Action(LoadBmwHistorySuccessAction)
     LoadBmwHistorySuccessAction({ patchState }: StateContext<CustomsStateModel>, action: LoadBmwHistorySuccessAction) {
       patchState({
         isLoading: false,
         customsMessages: action.payload.history
       });
     }

     @Action(LoadBmwHistoryFailAction)
     LoadBmwHistoryFailAction(ctx: StateContext<CustomsStateModel>, action: LoadBmwHistoryFailAction) {
       ctx.patchState({
         isLoading: false,
         customsMessages: []
       });
     }

   //------------------------------------------------------------------------------------------------------------------------------------------


  @Action(AddCustomsMessageByIdAction)
  AddCustomsMessageByIdAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: AddCustomsMessageByIdAction) {
      // Set "recently sent" immediately so we can skip our own SignalR echo (which may arrive before API response)
      patchState({
          isLoading: true,
          lastSentCustomsMessageTourId: action.id,
          lastSentCustomsMessageAt: Date.now()
      });

      return this.customsClient.addCustomsHistoryById(action.id, action.message, action.isCustomRole).pipe(
          tap((tour) => {
              dispatch(new AddCustomsMessageByIdSuccessAction({ tour }));
          }),
          catchError(error => {
              dispatch(new AddCustomsMessageByIdFailAction());
              throw error;
          })
      );
  }

  @Action(AddCustomsMessageByIdSuccessAction)
  AddCustomsMessageByIdSuccessAction({ patchState }: StateContext<CustomsStateModel>, action: AddCustomsMessageByIdSuccessAction) {
      // lastSentCustomsMessageTourId/lastSentCustomsMessageAt already set at send time to avoid race with SignalR
  }

    @Action(AddBmwMessageByIdAction)
    AddBmwMessageByIdAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: AddBmwMessageByIdAction) {
      patchState({
        isLoading: true,
        lastSentCustomsMessageTourId: action.id,
        lastSentCustomsMessageAt: Date.now()
      });

      const encodedMessage = encodeURIComponent(action.message || "");
      const url = `${environment.webApiBaseAddress}/api/BmwChats/AddBmwChatHistoryByTourId/${action.id}?message=${encodedMessage}&isBmwRole=${action.isBmwRole}`;
      return this.http.put<any>(url, {}).pipe(
        map((tour) => CustomsHistoryModel.fromJS(tour)),
        tap((tour) => {
          dispatch(new AddBmwMessageByIdSuccessAction({ tour }));
        }),
        catchError(error => {
          dispatch(new AddBmwMessageByIdFailAction());
          throw error;
        })
      );
    }

    @Action(AddBmwMessageByIdSuccessAction)
    AddBmwMessageByIdSuccessAction({ patchState }: StateContext<CustomsStateModel>, action: AddBmwMessageByIdSuccessAction) {
      // The local message is already added optimistically by the dialog.
    }

    @Action(AddBmwMessageByIdFailAction)
    AddBmwMessageByIdFailAction({ patchState }: StateContext<CustomsStateModel>) {
      patchState({ isLoading: false });
    }

//------------------------------------------------------------------------------------------------------------------------------------------

  @Action(MarkChatAsResolvedAction)
  MarkChatAsResolvedAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: MarkChatAsResolvedAction) {
        patchState({ isLoading: true });

        return this.customsClient.markChatResolved(action.id, action.tourId).pipe(
            tap((chat) => {
                dispatch(new MarkChatAsResolvedSuccessAction({ chat }));
            }),
            catchError(error => {
                dispatch(new MarkChatAsResolvedFailAction());
                throw error;
            })
        );
    }

    @Action(MarkChatAsResolvedSuccessAction)
    MarkChatAsResolvedSuccessAction({ patchState, getState }: StateContext<CustomsStateModel>, action: MarkChatAsResolvedSuccessAction) {
        const state = getState();
    }



  //-----------------------------------------------------------------------------------------------------------------------------------------

  @Action(SetCustomsDepartmentsFilterAction)
  SetCustomsDepartmentsFilterAction({ patchState, dispatch }: StateContext<CustomsStateModel>, action: SetCustomsDepartmentsFilterAction) {
        patchState({
            selectedDepartments: action.payload.selectedDepartments
        });

        dispatch(new ApplyFiltersToCustomsAction());
  }


  @Action(SetGoodsLoadedFilterAction)
    setGoodsLoadedFilterAction({ patchState, dispatch }: StateContext<CustomsStateModel>, action: SetGoodsLoadedFilterAction) {
        patchState({
            selectedGoodsLoaded: action.payload.selectedGoodsLoaded
        });

        dispatch(new ApplyFiltersToCustomsAction());
    }

    @Action(SetCustomsStatusFilterAction)
    setCustomsStatusFilterAction({ patchState, dispatch }: StateContext<CustomsStateModel>, action: SetCustomsStatusFilterAction) {
        patchState({
            selectedCustomsStatus: action.payload.selectedCustomsStatus
        });

        dispatch(new ApplyFiltersToCustomsAction());
    }

  @Action(SetCustomsTypesFilterAction)
  setCustomsTypesFilterAction({ patchState, dispatch }: StateContext<CustomsStateModel>, action: SetCustomsTypesFilterAction) {
        patchState({
            selectedTypes: action.payload.selectedTypes
        });

        dispatch(new ApplyFiltersToCustomsAction());
  }

  @Action(SetDeclarationTypeAction)
  setDeclarationTypeAction({ patchState, dispatch }: StateContext<CustomsStateModel>, action: SetDeclarationTypeAction) {
        patchState({
            selectedDeclarationType: action.payload.selectedDeclarationType
        });

        dispatch(new ApplyFiltersToCustomsAction());
  }

  @Action(SetCustomsCategoryFilterAction)
  setCustomsCategoryFilterAction({ patchState, dispatch }: StateContext<CustomsStateModel>, action: SetCustomsCategoryFilterAction) {
      patchState({
          selectedCategory: action.payload.selectedCategory
      });

      dispatch(new ApplyFiltersToCustomsAction());
  }

  @Action(UpdateCustomByTourIdAction)
    UpdateCustomByTourIdAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: UpdateCustomByTourIdAction) {
        patchState({ isLoading: true });

        return this.customsClient.updateCustomByTourId(action.tourId, action.estimatedDateTime, action.updateType, action.note).pipe(
            tap((custom) => {
                dispatch(new UpdateCustomByTourIdSuccessAction({ custom }));
            }),
            catchError((error) => {
                dispatch(new UpdateCustomByTourIdFailAction());
                throw error;
            })
        );
    }

    @Action(UpdateCustomByTourIdSuccessAction)
    UpdateCustomByTourIdSuccessAction({ dispatch, getState, patchState }: StateContext<CustomsStateModel>, action: UpdateCustomByTourIdSuccessAction) {
        const state = getState();
        const updatedCustomsList = state.customsList.map(custom =>
            custom.tourId === action.payload.custom.tourId ? action.payload.custom : custom
        );

        patchState({
            isLoading: false,
            customsList: updatedCustomsList
        });

        // Refresh the filtered list
        dispatch(new ApplyFiltersToCustomsAction());
    }

    @Action(UpdateCustomByTourIdFailAction)
    UpdateCustomByTourIdFailAction({ patchState }: StateContext<CustomsStateModel>) {
        patchState({
            isLoading: false
        });
    }

    // Allocate User
    @Action(AllocateUserByTourIdAction)
    AllocateUserByTourIdAction(
        { dispatch, patchState }: StateContext<CustomsStateModel>,
        action: AllocateUserByTourIdAction
    ) {
        patchState({ isAllocating: true });

        return this.customsClient.allocateUserByTourId(action.id).pipe(
            tap((tour) => {
                dispatch(new AllocateUserByTourIdSuccessAction({ tour }));
            }),
            catchError((error) => {
                dispatch(new AllocateUserByTourIdFailAction());
                throw error;
            })
        );
    }

    @Action(AllocateUserByTourIdSuccessAction)
    AllocateUserByTourIdSuccessAction(
        { getState, patchState }: StateContext<CustomsStateModel>,
        action: AllocateUserByTourIdSuccessAction
    ) {
        const state = getState();
        const updatedCustomsList = state.customsList.map(custom =>
            custom.tourId === action.payload.tour.id
                ? { ...custom, assignedUser: action.payload.tour.assignedUser } as unknown as CustomsModel
                : custom
        );

        patchState({
            customsList: updatedCustomsList,
            filteredList: this.filterCustoms(
                updatedCustomsList,
                state.selectedCategory,
                state.selectedDepartments,
                state.selectedTypes,
                state.selectedDeclarationType,
                state.selectedGoodsLoaded,
                state.selectedCustomsStatus
            ),
            isAllocating: false
        });
    }

    @Action(AllocateUserByTourIdFailAction)
    AllocateUserByTourIdFailAction(
        { patchState }: StateContext<CustomsStateModel>
    ) {
        patchState({
            isAllocating: false
        });
    }

    //Get documents
    @Action(GetDocumentsByAmcoIdAction)
    GetDocumentsByAmcoIdAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: GetDocumentsByAmcoIdAction) {
        patchState({ isLoadingDocuments: true });

        return this.customsClient.getDocumentsByAmcoId(action.amcoId).pipe(
            tap((documents) => {
                dispatch(new GetDocumentsByAmcoIdSuccessAction({ documents }));
            }),
            catchError((error) => {
                dispatch(new GetDocumentsByAmcoIdFailAction());
                throw error;
            })
        );
    }

    @Action(GetDocumentsByAmcoIdSuccessAction)
    GetDocumentsByAmcoIdSuccessAction({ patchState }: StateContext<CustomsStateModel>, action: GetDocumentsByAmcoIdSuccessAction) {
        patchState({
            isLoadingDocuments: false,
            documents: action.payload.documents
        });
    }

    @Action(GetDocumentsByAmcoIdFailAction)
    GetDocumentsByAmcoIdFailAction({ patchState }: StateContext<CustomsStateModel>) {
        patchState({
            isLoadingDocuments: false,
            documents: []
        });
    }

    //Upload document
    @Action(UploadDocumentAction)
    UploadDocumentAction(
        { dispatch, patchState }: StateContext<CustomsStateModel>,
        action: UploadDocumentAction
    ) {
        patchState({ isUploadingDocument: true });

        const formData = new FormData();
        formData.append('amcoId', action.amcoId.toString());
        formData.append('File', action.file, action.file.name);
        formData.append('fileType', action.documentType);

        return this.cusDocumentsService.uploadDocuments(formData).pipe(
            filter((event: HttpEvent<any>) => event.type === HttpEventType.Response),
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    return event.body as DocumentsModel;
                }
                return null;
            }),
            tap((document: DocumentsModel | null) => {
                if (document) {
                    dispatch(new UploadDocumentSuccessAction({ document: document, amcoId: action.Id }));
                }
            }),
            catchError((error) => {
                console.error('Upload error:', error);
                if (error.error) {
                    console.error('Error details:', error.error);
                }
                dispatch(new UploadDocumentFailAction());
                return of(error);
            })
        );
    }

    @Action(UploadDocumentSuccessAction)
    UploadDocumentSuccessAction({ dispatch, patchState, getState }: StateContext<CustomsStateModel>, action: UploadDocumentSuccessAction) {
        patchState({
            isUploadingDocument: false,
            documents: [...getState().documents, action.payload.document]
        });
        dispatch(new GetDocumentsByAmcoIdAction(action.payload.amcoId));
    }

    @Action(UploadDocumentFailAction)
    UploadDocumentFailAction({ patchState }: StateContext<CustomsStateModel>) {
        patchState({ isUploadingDocument: false });
    }

    // Upload Multiple Documents
    @Action(UploadMultipleDocumentsAction)
    UploadMultipleDocumentsAction(
        { dispatch, patchState }: StateContext<CustomsStateModel>,
        action: UploadMultipleDocumentsAction
    ) {
        patchState({ isUploadingDocument: true });

        const formData = new FormData();
        formData.append('amcoId', action.amcoId.toString());

        // Add all files with individual file types
        action.files.forEach((file, index) => {
            formData.append('Files', file, file.name);
            formData.append(`fileType_${index}`, action.documentTypes[index]);
        });

        // Debug logging
        console.log('UploadMultipleDocumentsAction - FormData contents:');
        console.log('amcoId:', action.amcoId);
        console.log('files count:', action.files.length);
        console.log('documentTypes:', action.documentTypes);

        // Log individual file types being sent
        action.documentTypes.forEach((type, index) => {
            console.log(`fileType_${index}:`, type);
        });

        return this.cusDocumentsService.uploadDocuments(formData).pipe(
            filter((event: HttpEvent<any>) => event.type === HttpEventType.Response),
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    return event.body as DocumentsModel[];
                }
                return null;
            }),
            tap((documents: DocumentsModel[] | null) => {
                if (documents) {
                    // Handle multiple documents with single success action
                    dispatch(new UploadMultipleDocumentsSuccessAction({ documents: documents, amcoId: action.Id }));
                }
            }),
            catchError((error) => {
                console.error('Upload error:', error);
                if (error.error) {
                    console.error('Error details:', error.error);
                }
                dispatch(new UploadDocumentFailAction());
                return of(error);
            })
        );
    }

    @Action(UploadMultipleDocumentsSuccessAction)
    UploadMultipleDocumentsSuccessAction({ dispatch, patchState, getState }: StateContext<CustomsStateModel>, action: UploadMultipleDocumentsSuccessAction) {
        const currentDocuments = getState().documents;
        const newDocuments = action.payload.documents;

        patchState({
            isUploadingDocument: false,
            documents: [...currentDocuments, ...newDocuments]
        });

        dispatch(new GetDocumentTypesAction(action.payload.amcoId));
    }

    // Download document
    @Action(DownloadDocumentAction)
    downloadDocumentAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: DownloadDocumentAction) {
        //patchState({ isLoadingDocuments: true });

        const fileName = encodeURIComponent(action.fileName);
        const url = `${environment.webApiBaseAddress}/api/Customs/DownloadDocument/${action.amcoId}/${fileName}`;


        return this.http.get(url, { responseType: 'blob' }).pipe(
            tap(blob => {
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = action.displayName || action.fileName;
                a.click();
                URL.revokeObjectURL(objectUrl);
                dispatch(new DownloadDocumentSuccessAction());
            }),
            catchError(error => {
                dispatch(new DownloadDocumentFailAction(error));
                throw error;
            })
        );
    }

    // View Documents
    @Action(ViewDocumentAction)
    viewDocumentAction({ dispatch }: StateContext<CustomsStateModel>, action: ViewDocumentAction) {
        const fileName = encodeURIComponent(action.fileName);
        const url = `${environment.webApiBaseAddress}/api/Customs/DownloadDocument/${action.amcoId}/${fileName}`;

        return this.http.get(url, { responseType: 'blob' }).pipe(
            tap(blob => {
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
            }),
            catchError(error => {
                dispatch(new ViewDocumentFailAction(error));
                throw error;
            })
        );
    }

  /// Apply filters
  @Action(ApplyFiltersToCustomsAction)
  applyFiltersToCustomsAction(ctx: StateContext<CustomsStateModel>, action: ApplyFiltersToCustomsAction) {
      const state = ctx.getState();
      const filteredC = this.filterCustoms(state.customsList, state.selectedCategory, state.selectedDepartments, state.selectedTypes, state.selectedDeclarationType, state.selectedGoodsLoaded, state.selectedCustomsStatus);

      ctx.patchState({
          filteredList: filteredC
      });
  }


  @Action(RegisterSignalRForCustomsAction)
  RegisterSignalRForCustomsAction({ getState, dispatch, patchState }: StateContext<CustomsStateModel>, action: RegisterSignalRForCustomsAction) {
    const updateCustomsList = (updatedCustoms: CustomsModel[]) => {

        patchState({
            customsList: updatedCustoms
        });

        dispatch(new LoadCustomsDashboardsV1Action());
        dispatch(new ApplyFiltersToCustomsAction());
    }


    this.signalRService.getHubConnection().on('SendCustomsList', (customList: CustomsModel[]) => {
        const state = getState();

        if (customList.length > 0) {

            const updatedTours = state.customsList ? state.customsList.map(existingJob => {
                if (typeof existingJob.updateDueDate === 'string') {
                    existingJob.updateDueDate = new Date(new Date(existingJob.updateDueDate).getTime());
                }

                if (typeof existingJob.lastModifiedDate === 'string') {
                    existingJob.lastModifiedDate = new Date(new Date(existingJob.lastModifiedDate).getTime());
                }

                //TO-DO : Use for ETA at Port of Departure
                /*if (typeof existingJob.plannedLoadingEnd === 'string') {
                        existingJob.estimatedDateTime = new Date(new Date(existingJob.estimatedDateTime).getTime());
                } */

                return existingJob;
            }) : customList;

            updateCustomsList(updatedTours);
        }
    });


    this.signalRService.getHubConnection().on('SendCustom', (updatedJob: CustomsModel) => {
        const state = getState();
        let updatedJobs: CustomsModel[] = [];

        if (typeof updatedJob.updateDueDate === 'string') {
            updatedJob.updateDueDate = new Date(new Date(updatedJob.updateDueDate).getTime());
        }

        if (typeof updatedJob.lastModifiedDate === 'string') {
            updatedJob.lastModifiedDate = new Date(new Date(updatedJob.lastModifiedDate).getTime());
        }

        //TO-DO : Use for ETA at Port of Departure
        /*if (typeof updatedJob.estimatedDateTime === 'string') {
            updatedJob.estimatedDateTime = new Date(new Date(updatedJob.estimatedDateTime).getTime());
        }*/

        updateCustomsList(updatedJobs);
    });

    // Listen for new customs chat messages
    this.signalRService.getHubConnection().on('SendCustomsHistory', (message: CustomsHistoryModel) => {
        const state = getState();

        // Do not show notification or red dot to the sender - skip if we recently sent to this tour
        const recentlySentByMe = state.lastSentCustomsMessageTourId != null &&
            message.tourId === state.lastSentCustomsMessageTourId &&
            state.lastSentCustomsMessageAt != null &&
            (Date.now() - state.lastSentCustomsMessageAt) < 5000;
        if (recentlySentByMe) {
            return;
        }

        // If message is from Tracking side (sent from managed-tours list), show notification on customs listing side
        if (message.type === "Tracking") {
            // Show snackbar notification
            this.store.dispatch(new OpenSnackbarAction({
                message: `New customs message received for tour ${message.amcoId || message.tourId}`,
                type: SnackbarType.Simple
            }));

            // Set has new messages flag for customs listing side
            dispatch(new SetHasNewMessagesForCustomsListAction({ hasNewMessages: true }));

            // Reload open chats list to update counts
            dispatch(new LoadListOfOpenChatsAction());
        }
        // If message is from Customs side (sent from customs listing), show notification on managed-tours side
        else if (message.type === "Customs") {
            // Show snackbar notification
            this.store.dispatch(new OpenSnackbarAction({
                message: `New customs message received for tour ${message.amcoId || message.tourId}`,
                type: SnackbarType.Simple
            }));

            // Set has new messages flag for managed tours side
            dispatch(new SetHasNewMessagesForManagedToursAction({ hasNewMessages: true }));

            // Reload open chats list to update counts
            dispatch(new LoadListOfOpenChatsAction());
        }
    });

    patchState({
        signalRHandlersRegistered: true
    });


  }



  private filterCustoms(
    customs: CustomsModel[],
    selectedCategory: string,
    selectedDepartments: number[],
    selectedTypes: number[],
    selectedDeclarationType: string[],
    selectedGoodsLoaded: boolean[],
    selectedCustomsStatus: string[]
  ): CustomsModel[] {

    const filteredCustoms = customs.filter(c => {

      const sixHoursAhead = new Date();
      sixHoursAhead.setHours(sixHoursAhead.getHours() + 6);

      const goodsLoadedMatch =
        selectedGoodsLoaded.length === 0 ||
        selectedGoodsLoaded.includes(c.goodsCollected === null ? false : true);

      const customsStatusMatch =
        selectedCustomsStatus.length === 0 ||
        selectedCustomsStatus.includes(c.customsStatus);

      const departmentMatch =
        selectedDepartments.length === 0 ||
        selectedDepartments.includes(c.departmentLookupId);

      const typeMatch =
        selectedTypes.length === 0 ||
        selectedTypes.includes(c.typeLookupId);

      const declarationMatch =
        selectedDeclarationType.length === 0 ||
        selectedDeclarationType.includes(c.declarationType);


      if (selectedCategory === 'All Jobs') {

        const allowedDeclarationTypes = [
          'Export EAD only',
          'Export TAD only',
          'Export EAD & TAD',
          'Import FFD',
          'Export EXS - Empty packaging',
          'Export EAD & EXS',
          'Export TAD & EXS',
          'Export EAD, TAD & EXS',
          'Done by Amco Agent',
          'Bonded Receipt',
          'Bonded Removals',
          'EU to GB Export Clearance',
          'EU to GB Export & Import FFD Clearance',
          'Import FFD & ENS',
          'Import ENS',
          'Export EAD & TAD'
        ];

        const allowedStatuses = [
          'New Export File',
          'Commercial docs received',
          'Awaiting TAD closure',
          'Awaiting Export Clearance',
          'New Import file',
          'Awaiting Import Clearance',
          'Import Prelodged',
          'Bond Receipt Awaiting Claim',
          'Bond Receipt Prelodged',
          'New Bond Removal File',
          'Import Customs complete'
        ];

        return (
          allowedDeclarationTypes.includes(c.declarationType) &&
          allowedStatuses.includes(c.customsStatus) &&
          departmentMatch &&
          typeMatch &&
          declarationMatch &&
          goodsLoadedMatch &&
          customsStatusMatch
        );
      }
      else if (selectedCategory === 'Awaiting clearance') {

        const statusMatch = [
          'New Export File',
          'New Import file',
          'Awaiting Import Clearance'
        ].includes(c.customsStatus);

        return (
          statusMatch &&
          departmentMatch &&
          typeMatch &&
          declarationMatch &&
          goodsLoadedMatch &&
          customsStatusMatch
        );
      }

      else if (selectedCategory === 'Inventory linked') {

        const allowedCustomsStatuses = [
          'New Export File',
          'Awaiting TAD closure',
          'New Import file',
          'Awaiting Import Clearance',
          'Import Prelodged'
        ];



        return (
          allowedCustomsStatuses.includes(c.customsStatus) &&
          c.inventoryLinked === true &&
          departmentMatch &&
          typeMatch &&
          declarationMatch &&
          goodsLoadedMatch &&
          customsStatusMatch
        );
      }
      else if (selectedCategory === 'HMRC Issues') {

        const validStatus = [
          'New Export File',
          'Awaiting TAD closure',
          'New Import file',
          'Awaiting Import Clearance',
          'Import Prelodged'
        ];

        const hmrcStatuses = [
          'Validation Error',
          'Rejected',
          'HMRC Documentary Control',
          'HMRC Physical Control',
          'Accounting Failure'
        ];

        return (
          validStatus.includes(c.customsStatus) &&
          hmrcStatuses.includes(c.hmrcStatus) &&
          departmentMatch &&
          typeMatch &&
          declarationMatch &&
          goodsLoadedMatch &&
          customsStatusMatch
        );
      }

      else if (selectedCategory === 'Prelodged Decs') {

        return (
          c.customsStatus === 'Import Prelodged' &&
          departmentMatch &&
          typeMatch &&
          declarationMatch &&
          goodsLoadedMatch &&
          customsStatusMatch
        );
      }
      else if (selectedCategory === 'TADS Awaiting Closure') {

        return (
          c.customsStatus === 'Awaiting TAD closure' &&
          departmentMatch &&
          typeMatch &&
          declarationMatch &&
          goodsLoadedMatch &&
          customsStatusMatch
        );
      }
      else {

        const within6Hours = c.updateDueDate < sixHoursAhead;

        return (
          departmentMatch &&
          typeMatch &&
          declarationMatch &&
          within6Hours &&
          goodsLoadedMatch &&
          customsStatusMatch
        );
      }

    });

    return filteredCustoms;
  }

  // Get Document Types
  @Action(GetDocumentTypesAction)
  GetDocumentTypesAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: GetDocumentTypesAction) {
    patchState({ isLoadingDocuments: true });

    return this.customsClient.getDocumentTypes(action.amcoId).pipe(
      tap((documentTypes) => {
        dispatch(new GetDocumentTypesSuccessAction({ documentTypes }));
      }),
      catchError((error) => {
        dispatch(new GetDocumentTypesFailAction(error));
        throw error;
      })
    );
  }

  @Action(GetDocumentTypesSuccessAction)
  GetDocumentTypesSuccessAction({ patchState }: StateContext<CustomsStateModel>, action: GetDocumentTypesSuccessAction) {
    patchState({
      isLoadingDocuments: false,
      documentTypes: action.payload.documentTypes
    });
  }

  @Action(GetDocumentTypesFailAction)
  GetDocumentTypesFailAction({ patchState }: StateContext<CustomsStateModel>) {
    patchState({
      isLoadingDocuments: false,
      documentTypes: []
    });
  }

  // Update Document Type
  @Action(UpdateDocumentTypeAction)
  UpdateDocumentTypeAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: UpdateDocumentTypeAction) {
    patchState({ isUpdatingDocumentType: true });

    return this.customsClient.updateDocumentType(
      Number(action.amcoId),
      action.fileName,
      action.category
    ).pipe(
      tap((documentType) => {
        dispatch(new UpdateDocumentTypeSuccessAction({ documentType }));
        // Refresh documents after successful update
        dispatch(new GetDocumentsByAmcoIdAction(Number(action.amcoId)));
      }),
      catchError((error) => {
        dispatch(new UpdateDocumentTypeFailAction(error));
        throw error;
      })
    );
  }

  @Action(UpdateDocumentTypeSuccessAction)
  UpdateDocumentTypeSuccessAction({ patchState }: StateContext<CustomsStateModel>, action: UpdateDocumentTypeSuccessAction) {
    patchState({
      isUpdatingDocumentType: false
    });
  }

  @Action(UpdateDocumentTypeFailAction)
  UpdateDocumentTypeFailAction({ patchState }: StateContext<CustomsStateModel>) {
    patchState({
      isUpdatingDocumentType: false
    });
  }

  @Action(ClearDocumentsAction)
  ClearDocumentsAction({ patchState }: StateContext<CustomsStateModel>) {
    patchState({
      documents: [],
      documentTypes: [],
      isLoadingDocuments: false
    });
  }

  // Update Documents Checked
  @Action(UpdateDocumentsCheckedAction)
  UpdateDocumentsCheckedAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: UpdateDocumentsCheckedAction) {
    patchState({ isUpdatingDocumentsChecked: true });

    return this.customsClient.updateDocumentsChecked(action.amcoId).pipe(
      tap(() => {
        dispatch(new UpdateDocumentsCheckedSuccessAction({ amcoId: action.amcoId }));
      }),
      catchError((error) => {
        dispatch(new UpdateDocumentsCheckedFailAction(error));
        throw error;
      })
    );
  }

  @Action(UpdateDocumentsCheckedSuccessAction)
  UpdateDocumentsCheckedSuccessAction({ patchState }: StateContext<CustomsStateModel>, action: UpdateDocumentsCheckedSuccessAction) {
    patchState({
      isUpdatingDocumentsChecked: false
    });
  }

  @Action(UpdateDocumentsCheckedFailAction)
  UpdateDocumentsCheckedFailAction({ patchState }: StateContext<CustomsStateModel>) {
    patchState({
      isUpdatingDocumentsChecked: false
    });
  }

  // Update UCN Checked
  @Action(UpdateUncCheckedAction)
  UpdateUncCheckedAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: UpdateUncCheckedAction) {
    patchState({ isUpdatingUncChecked: true });

    return this.customsClient.updateUncChecked(action.amcoId).pipe(
      tap(() => {
        dispatch(new UpdateUncCheckedSuccessAction({ amcoId: action.amcoId }));
      }),
      catchError((error) => {
        dispatch(new UpdateUncCheckedFailAction(error));
        throw error;
      })
    );
  }

  @Action(UpdateUncCheckedSuccessAction)
  UpdateUncCheckedSuccessAction({ patchState }: StateContext<CustomsStateModel>, action: UpdateUncCheckedSuccessAction) {
    patchState({
      isUpdatingUncChecked: false
    });
  }

  @Action(UpdateUncCheckedFailAction)
  UpdateUncCheckedFailAction({ patchState }: StateContext<CustomsStateModel>) {
    patchState({
      isUpdatingUncChecked: false
    });
  }

  // Update TAD Closed
  @Action(UpdateTadClosedAction)
  UpdateTadClosedAction({ dispatch, patchState }: StateContext<CustomsStateModel>, action: UpdateTadClosedAction) {
    patchState({ isUpdatingTadClosed: true });

    return this.customsClient.updateTadClosed(action.amcoId).pipe(
      tap(() => {
        dispatch(new UpdateTadClosedSuccessAction({ amcoId: action.amcoId }));
      }),
      catchError((error) => {
        dispatch(new UpdateTadClosedFailAction(error));
        throw error;
      })
    );
  }

  @Action(UpdateTadClosedSuccessAction)
  UpdateTadClosedSuccessAction({ patchState }: StateContext<CustomsStateModel>, action: UpdateTadClosedSuccessAction) {
    patchState({
      isUpdatingTadClosed: false
    });
  }

  @Action(UpdateTadClosedFailAction)
  UpdateTadClosedFailAction({ patchState }: StateContext<CustomsStateModel>) {
    patchState({
      isUpdatingTadClosed: false
    });
  }

  @Action(SetHasNewMessagesForCustomsListAction)
  SetHasNewMessagesForCustomsListAction({ patchState }: StateContext<CustomsStateModel>, action: SetHasNewMessagesForCustomsListAction) {
    patchState({
      hasNewMessagesForCustomsList: action.payload.hasNewMessages
    });
  }

  @Action(ClearNewMessagesForCustomsListAction)
  ClearNewMessagesForCustomsListAction({ patchState }: StateContext<CustomsStateModel>) {
    patchState({
      hasNewMessagesForCustomsList: false
    });
  }

  @Action(SetHasNewMessagesForManagedToursAction)
  SetHasNewMessagesForManagedToursAction({ patchState }: StateContext<CustomsStateModel>, action: SetHasNewMessagesForManagedToursAction) {
    patchState({
      hasNewMessagesForManagedTours: action.payload.hasNewMessages
    });
  }

  @Action(ClearNewMessagesForManagedToursAction)
  ClearNewMessagesForManagedToursAction({ patchState }: StateContext<CustomsStateModel>) {
    patchState({
      hasNewMessagesForManagedTours: false
    });
  }
}
